import "@/App.css";
import { motion } from "framer-motion";

const LINK = "https://www.approtinaleve.com/";

const FacebookLogo = () => (
  <svg
    viewBox="0 0 36 36"
    width="30"
    height="30"
    fill="url(#fb-gradient)"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="fb-gradient" x1="50%" x2="50%" y1="97.078%" y2="0%">
        <stop offset="0%" stopColor="#0062E0" />
        <stop offset="100%" stopColor="#19AFFF" />
      </linearGradient>
    </defs>
    <path d="M15 35.8C6.5 34.3 0 26.9 0 18 0 8.1 8.1 0 18 0s18 8.1 18 18c0 8.9-6.5 16.3-15 17.8l-1-.8h-4l-1 .8z" />
    <path
      fill="#FFF"
      d="M25 23l.8-5H21v-3.5c0-1.4.5-2.5 2.7-2.5H26V7.4c-1.3-.2-2.7-.4-4-.4-4.1 0-7 2.5-7 7v4h-4.5v5H15v12.7c1 .2 2 .3 3 .3s2-.1 3-.3V23h4z"
    />
  </svg>
);

function App() {
  return (
    <div className="fb-page">
      <motion.header
        className="fb-brand"
        data-testid="facebook-brand"
        initial={{ opacity: 0, y: -8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        <FacebookLogo />
        <span className="fb-brand__name">Facebook</span>
      </motion.header>

      <motion.div
        className="fb-card"
        data-testid="cookie-card"
        initial={{ opacity: 0, y: 24, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      >
        <h1 className="fb-card__title" data-testid="cookie-title">
          Preferências de cookies
        </h1>
        <p className="fb-card__text">
          Este site pode utilizar cookies para melhorar a experiência de
          navegação. Escolha se deseja aceitar ou recusar cookies opcionais para
          continuar.
        </p>

        <a
          className="fb-btn fb-btn--primary"
          data-testid="accept-button"
          href={LINK}
        >
          Aceitar
        </a>
        <a
          className="fb-btn fb-btn--secondary"
          data-testid="decline-button"
          href={LINK}
        >
          Recusar
        </a>
      </motion.div>
    </div>
  );
}

export default App;
